import React from "react";
import { ModeRendererProps } from "./types";

export function JansenLegsMode({ brand }: ModeRendererProps) {
  return (
    <g>
      <g transform="translate(397 540)">
        {/* Central hub */}
        <circle r="40" fill={brand.deep} stroke={brand.white} strokeWidth="4" />
        
        {/* Radiating leg mechanisms */}
        {Array.from({ length: 12 }).map((_, i) => {
          const angle = (i * Math.PI * 2) / 12;
          const phase = (i * 30) % 360;
          return (
            <g key={i} transform={`rotate(${i * 30})`}>
              <line x1="0" y1="0" x2="0" y2="-250" stroke={brand.violet} strokeWidth="2" opacity="0.3" />
              <g transform={`translate(0 -150) rotate(${phase})`}>
                <use href="#jansenLeg" transform="scale(0.6)" />
              </g>
            </g>
          );
        })}
        
        {/* Motion circles */}
        {Array.from({ length: 6 }).map((_, i) => (
          <circle
            key={i}
            r={80 + i * 40}
            fill="none"
            stroke={i % 2 ? brand.aqua : brand.amber}
            strokeWidth="1"
            strokeDasharray="8 12"
            opacity={0.4 - i * 0.05}
          />
        ))}
        
        {/* Trajectory dots */}
        {Array.from({ length: 60 }).map((_, i) => {
          const angle = (i * Math.PI * 2) / 60;
          const r = 200 + 20 * Math.sin(i * 0.3);
          const x = r * Math.cos(angle);
          const y = r * Math.sin(angle);
          return <circle key={i} cx={x} cy={y} r="2" fill={brand.green} opacity={0.6} />;
        })}
      </g>
    </g>
  );
}
